import { render, staticRenderFns } from "./AdminProviderUpdate.vue?vue&type=template&id=2f2aaef0"
import script from "./AdminProviderUpdate.vue?vue&type=script&lang=js"
export * from "./AdminProviderUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports